import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface GameState {
  currentGameExtId: string | null
}

const initialState: GameState = {
  currentGameExtId: null,
}

export const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    setCurrentGameExtId: (state, action: PayloadAction<string | null>) => {
      state.currentGameExtId = action.payload
    },
  },
})

export const { setCurrentGameExtId } = gameSlice.actions

export default gameSlice.reducer
